// Valores del sistema visual del recorrido (docs/pricing/bocetos/recorrido/proa-ui.css).
export const J = {
  bg: '#020617',
  panel: '#081120',
  card: 'rgba(15,23,42,.72)',
  border: '#1e293b',
  borderStrong: '#334155',
  inputBg: '#0b1424',
  inputBorder: 'rgba(148,163,184,.28)',
  text: '#f8fafc',
  body: '#cbd5e1',
  muted: '#94a3b8',
  sky: '#38bdf8',
  skyText: '#7dd3fc',
  onSky: '#0f172a',
  amber: '#fcd34d',
  danger: '#f87171',
  dangerText: '#fca5a5',
  ok: '#4ade80',
  okText: '#86efac',
  radiusControl: '10px',
  radiusCard: '16px',
  font: '"Inter", system-ui, sans-serif',
} as const;

export type JourneyTone = 'info' | 'warn' | 'danger' | 'ok';

// Fondo, borde y texto de avisos, bandas y chips por tono.
export const TONE: Record<JourneyTone, { bg: string; border: string; text: string; accent: string }> = {
  info: { bg: 'rgba(56,189,248,.08)', border: 'rgba(56,189,248,.3)', text: '#e0f2fe', accent: J.skyText },
  warn: { bg: 'rgba(252,211,77,.08)', border: 'rgba(252,211,77,.38)', text: '#fef3c7', accent: J.amber },
  danger: { bg: 'rgba(248,113,113,.08)', border: 'rgba(248,113,113,.38)', text: '#fee2e2', accent: J.dangerText },
  ok: { bg: 'rgba(74,222,128,.08)', border: 'rgba(74,222,128,.35)', text: '#dcfce7', accent: J.okText },
};

